import React from "react";
import { Pagination } from "antd";

const CustomPagination = ({ pagination, onPageChange, onPageSizeChange }) => {
  const itemRender = (page, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };

  return (
    <Pagination
      style={{ margin: "0 0 1rem 0", display: "flex", justifyContent: "flex-end" }}
      current={pagination.page}
      pageSize={pagination.pageSize}
      total={pagination.total}
      showSizeChanger={true}
      pageSizeOptions={["10", "20", "50", "100"]}
      onChange={onPageChange}
      onShowSizeChange={(_, size) => onPageSizeChange(size)}
      itemRender={itemRender}
    />
  );
};

export default CustomPagination;
